import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class XsdWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.xsd.ID;
        this.name = DatabaseEnum.xsd.NAME;
        this.code = DatabaseEnum.xsd.CODE;
        this.equivalentTag = DatabaseEnum.xsd.EQUIVALENT_TAG;
        //data object tabs
        this.showDataObjectPropertiesTab = true;
        this.isShowObjProperties = true;
        this.isFileType = true;
        this.showPromoteAttributes = true;
        this.showDemoteAttributes=true
        this.showDataDescription = false;
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {

        if (!repConnWrapper.repConn.conn.consumerKey.length)
            repConnWrapper.inValid_Cds.push('CONSUMER_KEY');

        if (!repConnWrapper.repConn.conn.consumerSecret.length)
            repConnWrapper.inValid_Cds.push('CONSUMER_KEYSECRET');

        if (!repConnWrapper.repConn.conn.accessToken.length)
            repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');

        if (repConnWrapper.repConn.conn.flagent_Id == -1)
            repConnWrapper.inValid_Cds.push('ESM00202');
    }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
           this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getClevel(objectWrapper, true),//true
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrType_Cd(objectWrapper),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMinOccurs(objectWrapper),
            this.attributeTabulator.getOccurs(objectWrapper, 'Max Occurs'),
            this.attributeTabulator.getReferKey(objectWrapper),
            this.attributeTabulator.getDescription(objectWrapper)
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,isMax: boolean = false,component:any): Array<any> {
        return [
           this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper,component),
        ]
    }

    readFileCutOffLength(type: string): number {
        return -1;
    }
}
